import script from "./scanPay.vue?vue&type=script&setup=true&lang=js"
export * from "./scanPay.vue?vue&type=script&setup=true&lang=js"

import "./scanPay.vue?vue&type=style&index=0&id=edd57102&lang=less&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edd57102"]])

export default __exports__